import { IconProps } from '../../utils/icon';
import { Svg } from '../../utils/IconBase';

const IconDotLine = ({ width, height, fill = '#000000', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width="4" height="4" x="10" y="10" fill={fill} rx="2" />
    </Svg>
  );
};

export default IconDotLine;
